<div class="container-box">
  <!-- input fields -->
  <div class="filters-box">
    <app-table-search (search)="onSearch($event)" #searchCom></app-table-search>
    <div class="flex-fill"></div>
    <div
      *ngIf="isMainMultiUnit"
      class="auto-compact-toggle"
      matTooltip="The rooms needs to be identical for the compaction"
      matTooltipPosition="above"
      i18n-matTooltip
    >
      <app-form-switch
        [inline]="true"
        [value]="autoCompactEnabled"
        [disabled]="1 | isReadonlyRole"
        (valueChange)="onAutoCompactChange($event)"
      ></app-form-switch>
      <span i18n>Automatic compaction</span>
    </div>
    <button
      matTooltipPosition="above"
      [disabled]="1 | isReadonlyRole"
      type="button"
      class="btn btn-secondary-info"
      (click)="onAdd()"
    >
      <span class="far fa-plus"></span>
      <ng-container i18n>Add Subunit</ng-container>
    </button>
  </div>
  <div class="table-holder table-responsive">
    <table class="table table-default table-striped">
      <mat-table
        #table
        matSort
        matSortActive="multi_unit_priority"
        matSortDirection="desc"
        [dataSource]="dataSource"
        [trackBy]="trackBy"
      >
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Name</mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            <div
              [editable]="true"
              class="px-2 py-1 bg-white w-100"
              [ngModel]="element.name"
              #ctrl="ngModel"
              [disabled]="1 | isReadonlyRole"
              [ngModelOptions]="{ updateOn: 'blur' }"
              (ngModelChange)="$event ? onRentalNameChange(element, $event) : ctrl.reset(element.name)"
              required
            ></div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="multi_unit_status">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Status</mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            <app-form-switch
              [inline]="true"
              [value]="!!element.multi_unit_status"
              [disabled]="1 | isReadonlyRole"
              (valueChange)="onStatusChange(element, $event)"
              i18n-matTooltip
              matTooltip="When enabled, the subunit is active and available for bookings. When disabled, it cannot be booked but will still appear on the calendar as inactive. You can change this anytime"
            ></app-form-switch>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="multi_unit_priority">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <ng-container i18n>Priority</ng-container>&nbsp;
            <i
              class="fas fa-info-circle"
              matTooltip="Defines the booking order for subunits. Higher numbers get booked first."
            ></i>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            <div
              editable="plaintext-only"
              inputmode="numeric"
              (keydown)="onKeyDownPriority($event)"
              class="px-2 py-1 bg-white w-100"
              matTooltip="min is 1, max is 100"
              [ngModel]="element.multi_unit_priority"
              #ctrl="ngModel"
              [disabled]="1 | isReadonlyRole"
              [ngModelOptions]="{ updateOn: 'blur' }"
              (ngModelChange)="onRentalPriorityChange(element, $event, ctrl)"
              required
            ></div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef i18n>Edit</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
              <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
                <a class="btn-ellips">
                  <i class="fas fa-ellipsis-v"></i>
                </a>
              </div>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <li>
                  <button (click)="onEdit(element)" type="button">
                    <i class="far fa-edit"></i><ng-container i18n>Edit</ng-container>
                  </button>
                </li>
                <li>
                  <button (click)="onDelete(element)" type="button">
                    <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                  </button>
                </li>
              </ul>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" class="clickable" (click)="onEdit(row)"></mat-row>
      </mat-table>

      <mat-paginator2
        #paginator
        [length]="dataSource?.data?.length"
        [class.hidden]="isEmptyTable$ | async"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
        [showFirstLastButtons]="true"
      >
      </mat-paginator2>

      <app-empty-table
        *ngIf="isEmptyTable$ | async"
        [isFiltering]="!searchCom.isEmpty"
        [type]="'RentalsList'"
      ></app-empty-table>
    </table>
  </div>
</div>
